import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, registerLocaleData } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from '../app/app.component';
// shared modules
import { SharedModule } from '../app/shared/shared.module';
// ngrx store
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
// reducers
import { flightReducer } from '../app/booking/reducers/flight.reducer';
import { d2dReducer } from '../app/booking/reducers/d2d-booking.reducer';
import { upsellBookingReducer } from '../app/booking/reducers/upsell-booking.reducer';
import { bookingReducer } from '../app/booking/reducers/booking.reducer';
import { currentBookingReducer } from '../app/booking/reducers/current-booking.reducer';
import { userReducer } from '../app/shared/reducers/user.reducer';
import { priceReducer } from '../app/booking/reducers/price.reducer';
import { threeDS2Reducer } from './booking/reducers/threeDS2.reducer';
import { updatePanelReducer } from '../app/booking/reducers/panel.reducer';
import { copyReducer } from '../app/shared/reducers/copy.reducer';
import { loadedStatusReducer } from '../app/shared/reducers/loading-status.reducer';
import { flightFinderReducer } from '../app/shared/reducers/flight-finder.reducer';
import { partnerReducer } from '../app/shared/reducers/partner.reducer';
import { timeslotReducer } from '../app/booking/reducers/timeslot.reducer';
import { userAgentReducer } from '../app/shared/reducers/user-agent.reducer';
import { milesAndMoreReducer } from '../app/booking/reducers/milesAndMore.reducer';
import { utilityReducer } from '../app/shared/reducers/utility.reducer';
import { hubDropReducer } from '../app/booking/reducers/hubdrop.reducer';
import { flybackReducer } from '../app/booking/reducers/flyback.reducer';
import { oldBookingInfoReducer } from '../app/booking/reducers/old-booking-info.reducer';
// custom routes
import { AppRoutingModule } from '../app/app.routing';
// route guards
import { TrackBookingRouteGuard } from '../app/shared/route-guards/track-booking-route-guard';
// custom top level modules
import { LoginSectionModule } from '../app/login/login-section.module';
import { LoginOverlaySectionModule } from '../app/login-overlay/login-overlay-section.module';
import { RegisterSectionModule } from '../app/register/register-section.module';
import { VerifySectionModule } from '../app/verify/verify-section.module';
import { BookingSectionModule } from '../app/booking/booking-section.module';
import { FlybackBookingSectionModule } from '../app/booking/flyback-booking-section.module';
import { Error500Component } from '../app/error-pages/containers/error-500/error-500.component';
import { Error404Component } from '../app/error-pages/containers/error-404/error-404.component';
// moment js
import { MomentModule } from 'ngx-moment';

// datepicker
import { MatDatepickerModule } from '@angular/material/datepicker';
// services
import { EventsService } from '../app/booking/services/events.service';
import { LoginService } from '../app/shared/services/login.service';
import { ErrorHandler } from '../app/shared/services/error-handler.service';
import { BookingService } from '../app/booking/services/booking.service';
import { DataStorageService } from '../app/shared/services/data-storage.service';
import { FlightDetailsService } from '../app/shared/services/flight-details.service';
import { PriceService } from '../app/booking/services/price.service';
import { CopyService } from '../app/shared/services/app-copy.service';
import { UtilityService } from '../app/shared/services/utility.service';
import { TimeslotService } from '../app/booking/services/timeslots.service';
import { AbandonmentService } from '../app/shared/services/abandonment.service';
import { TooltipService } from '../app/shared/services/tooltip.service';
import { AppLoaderService } from '../app/shared/services/app-loader.service';
import { UserAgentService } from '../app/shared/services/user-agent.service';
import { SharedService } from '../app/shared/services/shared-service.service';
import { ExternalScriptsService } from '../app/shared/services/external-scripts.service';
import { ApplicationInsightsService } from '../app/shared/services/app-insights.service';
import { UpsellComponent } from './booking/components/upsell-timeslot/upsell.component';
// google maps
// import { AgmCoreModule } from '@agm/core';
//google-pay
import { GooglePayButtonModule } from '@google-pay/button-angular';
// import { LanguageSelectorComponent } from './language-selector/language-selector.component';
import localeFr from '@angular/common/locales/fr';
import localeDe from '@angular/common/locales/de';
import localeIt from '@angular/common/locales/it';
import { environment } from '../environments/environment';
registerLocaleData(localeFr);
registerLocaleData(localeDe);
registerLocaleData(localeIt);

@NgModule({
  declarations: [
    AppComponent,
    Error500Component,
    Error404Component,
    UpsellComponent,
    // LanguageSelectorComponent
  ],
  imports: [
    MomentModule,
    // BrowserModule.withServerTransition({ appId: 'portr-booking-form' }),
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    CommonModule,
    SharedModule,
    AppRoutingModule,
    LoginSectionModule,
    LoginOverlaySectionModule,
    RegisterSectionModule,
    BookingSectionModule,
    FlybackBookingSectionModule,
    VerifySectionModule,
    MatDatepickerModule,
    // AgmCoreModule.forRoot({
    //   apiKey: environment.googleAPIKey,
    //   libraries: ['places']
    // }),
    StoreModule.forRoot({
      partnerReducer,
      copyReducer,
      flightReducer,
      d2dReducer,
      bookingReducer,
      userReducer,
      currentBookingReducer,
      upsellBookingReducer,
      priceReducer,
      threeDS2Reducer,
      updatePanelReducer,
      loadedStatusReducer,
      flightFinderReducer,
      timeslotReducer,
      hubDropReducer,
      flybackReducer,
      userAgentReducer,
      milesAndMoreReducer,
      utilityReducer,
      oldBookingInfoReducer
    }),
    StoreDevtoolsModule.instrument(),
    GooglePayButtonModule
  ],
  providers: [
    EventsService,
    LoginService,
    ErrorHandler,
    BookingService,
    DataStorageService,
    FlightDetailsService,
    PriceService,
    CopyService,
    UtilityService,
    TimeslotService,
    AbandonmentService,
    TooltipService,
    AppLoaderService,
    UserAgentService,
    SharedService,
    ExternalScriptsService,
    ApplicationInsightsService,
    TrackBookingRouteGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

